import React, { useState, useEffect, useContext } from "react";
import { Helmet } from "react-helmet-async";
import Row from "../components/Row/Row";
import { useLocation } from "react-router-dom";
import { usePageContent } from "../hooks/useQueries";
import Loading from "../components/Loading/Loading.js";
import { TranslateContext } from "../App.js";

/**
 * Generic page component for pages and blog posts.
 * Renders dynamic rows of content.
 * Uses React Query for cached data fetching.
 */
function Page() {
  const location = useLocation();
  const slug = location.pathname.substring(1);
  const [rows, setRows] = useState([]);
  const language = useContext(TranslateContext).language;
  
  // Use React Query hook for cached page data
  const { data: content, isLoading } = usePageContent("blogpost", slug);

  useEffect(() => {
    if (content && content.rows) {
      setRows(content.rows);
    }
  }, [content]);

  if (isLoading) {
    return <Loading />;
  }

  return (
    content && (
      <>
        <Helmet>
          <title>{content.title[language]}</title>
          <meta name="description" content={content.metaDescription} />
        </Helmet>
        <div className="home w-screen min-h-[60vh] max-h-fit py-16">
          <h1 className="h1-title">{content.title[language]}</h1>
          {rows.map((row, index) => {
            return <Row columns={row.columns} bgColor={row.background?.color} key={`row-${index}`} />;
          })}
        </div>
      </>
    )
  );
}

export default Page;
